export default {"src":"/_next/static/image/public/images/flags/flag_257.5d1f893f6eac8a248596b666d5998210.svg","height":16,"width":24};